import { Platform, StyleSheet } from 'react-native';

import {
  ADMIN_TABLE_HEADER_SEARCH_HEIGHT,
  ADMIN_TABLE_HEADER_SEARCH_WIDTH,
  ADMIN_TABLE_ROW_HEIGHT,
} from './adminTableLayoutConstants';
import { adminTableColors } from './adminTableStyles';
import { colors } from '../../theme/colors';
import { layout, spacing } from '../../theme/spacing';

export const adminTableMemberGridStyles = StyleSheet.create({
  headerPrimary: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  headerSearch: {
    width: '100%',
    maxWidth: ADMIN_TABLE_HEADER_SEARCH_WIDTH,
    flexShrink: 1,
    minWidth: 0,
    height: ADMIN_TABLE_HEADER_SEARCH_HEIGHT,
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    borderWidth: 1,
    borderColor: colors.borderMedium,
    borderRadius: spacing.formControlBorderRadius,
    backgroundColor: colors.backgroundPrimary,
    paddingHorizontal: spacing.md,
  },
  headerSearchFocused: {
    borderColor: colors.primary,
  },
  headerSearchDisabled: {
    opacity: 0.5,
  },
  headerSearchInput: {
    flex: 1,
    color: colors.textPrimary,
    fontSize: 13,
    ...Platform.select({ web: { outlineWidth: 0 } }),
  },
  headerSearchInputAndroid: {
    paddingVertical: 0,
    includeFontPadding: false,
    textAlignVertical: 'center',
  },
  trailingHeader: {
    textAlign: 'right',
    paddingLeft: spacing.sm,
  },
  trailingHeaderCentered: {
    textAlign: 'center',
    paddingLeft: spacing.sm,
  },
  rightAligned: {
    textAlign: 'right',
  },
  emailCellCentered: {
    textAlign: 'center',
  },
  actionsColumn: {
    width: 44,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  gridBody: {
    width: '100%',
  },
  gridBodyContent: {
    justifyContent: 'flex-start',
  },
  gridRow: {
    height: ADMIN_TABLE_ROW_HEIGHT,
  },
  inlineMessageRow: {
    paddingVertical: spacing.md,
    paddingHorizontal: layout.users.tableSectionHorizontalPadding,
    borderBottomWidth: 1,
    borderBottomColor: adminTableColors.rowRule,
  },
  inlineMessageText: {
    fontSize: 13,
    color: adminTableColors.bodyMuted,
    textAlign: 'center',
  },
  rowAddButton: {
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
    borderRadius: spacing.formControlBorderRadius,
    backgroundColor: colors.primary,
    minHeight: 28,
    justifyContent: 'center',
  },
  rowAddButtonDisabled: {
    opacity: 0.5,
  },
  rowAddButtonText: {
    color: '#fff',
    fontSize: 13,
    fontWeight: '600',
  },
  rowIconAction: {
    padding: spacing.sm,
  },
  stateText: {
    color: colors.textSecondary,
    fontSize: 13,
    textAlign: 'center',
    paddingHorizontal: spacing.cardPadding,
    paddingVertical: spacing.pdPagePaddingVertical,
  },
  stateRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing.sm,
    paddingHorizontal: spacing.cardPadding,
    paddingVertical: spacing.pdPagePaddingVertical,
  },
  errorText: {
    color: colors.error,
    fontSize: 13,
  },
  retryText: {
    color: colors.primary,
    fontSize: 13,
    fontWeight: '600',
  },
});
